import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Dispatch';
import Calendar from "./components/DispatchCalendar";
import Active_Collection from "./components/UsersActive";
import Logs from "./components/DispatchLogs"
import ScheduleRouting from "./components/ScheduleRouting"
import FE_Availability from "./components/FEAvailability";
import RecentlyBooked from "./components/RecentlyBooked";
import EngineersTicketStatus from "./components/EngineersTicketStatus";
import OptimizeRoutes from "./components/OptimizeRoutes"
import TFO_Reschedules from "./components/TFOReschedules";
import Reschedule_Fourth from "./components/RescheduleFourth";
import SchedulesComponent from "./components/DispatcherSchedules";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import FELocationTrack from "./components/FELocationTrack";
import DispatchIdleTasks from "./components/DispatchIdleTasks";
import DailyEta from "./components/DailyEta";

export default ({match, regions,roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/active`}>
				<Active_Collection regions={regions} roles={roles} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/availability`}>
				<FE_Availability regions={regions} roles={roles} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/ticketsstatus`}>
				<EngineersTicketStatus regions={regions} roles={roles} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/daily_eta`}>
				<DailyEta regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/booked`}>
				<RecentlyBooked regions={regions} roles={roles} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/calendar/:id`}>
				<Calendar regions={regions} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/calendar/`}>
				<Calendar regions={regions} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/calendar_old/`}>
				<Calendar regions={regions} old={true}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/calendar/toDate/`}>
				<Calendar regions={regions} />
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/logs/`}>
				<Logs regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/closest/`}>
				<ScheduleRouting regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/felocation/`}>
				<FELocationTrack regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/mapped/`}>
				<OptimizeRoutes regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/tfos`}>
				<TFO_Reschedules regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/reschedulefourth`}>
				<Reschedule_Fourth regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/dispatchschedules`}>
				<SchedulesComponent regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/idle_tasks`}>
				<DispatchIdleTasks regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`} />
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
